import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalDirective } from 'ng-uikit-pro-standard';

@Component({
  selector: 'app-modal-info',
  templateUrl: './modal-info.component.html',
  styleUrls: ['./modal-info.component.scss']
})
export class ModalInfoComponent implements OnInit {


  @ViewChild('modalInfo', { static: true }) modalInfo: ModalDirective

  // Input
  @Input() title: String = ""
  @Input() contentText: String = ""
  // @Input() acceptButtonText: String = "Aceptar"
  // @Input() cancelButtonText: String = "Cancelar"

  // Output
  // @Output() onAccept: EventEmitter<any> = new EventEmitter<any>();
  @Output() onClose: EventEmitter<any> = new EventEmitter<any>();

  // Callbacks
  private closeCallback: Function;

  constructor() { }

  ngOnInit() {
  }

  /********* SHOW/HIDE *********/
  show(closeCallback: Function = null) {
    this.closeCallback = closeCallback
    this.modalInfo.show();
  }

  showWithInlineConfig(title: string, contentText: string, closeCallback: Function = null) {
    this.title = title
    this.contentText = contentText
    this.closeCallback = closeCallback
    this.modalInfo.show();
  }

  hide() {
    this.modalInfo.hide();
  }
  /********* SHOW/HIDE *********/

  /********* OPERATIONS *********/
  // accept() {
  //   if (this.acceptCallback)
  //     this.acceptCallback()
  //   this.onAccept.emit();
  //   this.hide()
  // }

  cancel() {
    if (this.closeCallback)
      this.closeCallback()
    this.onClose.emit();
    this.hide()
  }
  /********* OPERATIONS *********/

}
